import { useMutation } from '@tanstack/react-query';
import { getGlobalConfig } from '@dealstack/frontend/shared/globalConfig';

/**
 * Invite the witness a public signer (representative) nominated. Fired from the
 * signing completion handler, mirroring the investor flow which invites its witness
 * once the signer's own signature completes. The signing token travels in the body
 * (read by the public-signing middleware); the endpoint itself is unauthenticated.
 */
async function postWitnessInvite(token: string, witnessEmail: string): Promise<void> {
	const config = getGlobalConfig();
	const response = await fetch(`${config.apiUrl}/public-signing/invite-witness`, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ token, witnessEmail }),
	});
	if (!response.ok) {
		throw new Error(`Witness invite failed: ${response.status}`);
	}
}

export const useInviteWitness = (token: string) => {
	const mutation = useMutation({
		mutationFn: (witnessEmail: string) => postWitnessInvite(token, witnessEmail),
	});

	return {
		mutate: (witnessEmail: string, options?: Parameters<typeof mutation.mutate>[1]) =>
			mutation.mutate(witnessEmail, options),
		isPending: mutation.isPending,
		isError: mutation.isError,
	};
};
